var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ModuleContainer,
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "btn",
            fn: function () {
              return [
                _c(
                  _setup.MapControlButton,
                  {
                    attrs: {
                      tooltip: _setup.$map.trans("map.crs-control.title"),
                    },
                    on: { click: _setup.onToggleShow },
                  },
                  [
                    _c(_setup.SvgIcon, {
                      attrs: {
                        size: 18,
                        type: "mdi",
                        path: _setup.mdiInboxOutline,
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "draggable",
            fn: function (props) {
              return [
                _setup.show
                  ? _c(
                      _setup.DraggablePopup,
                      _vm._b(
                        {
                          attrs: {
                            height: 200,
                            width: 400,
                            show: _setup.show,
                            title: _setup.$map.trans("map.crs-control.title"),
                          },
                          on: {
                            "update:show": function ($event) {
                              _setup.show = $event
                            },
                          },
                        },
                        "DraggablePopup",
                        props,
                        false
                      ),
                      [
                        _vm._l(_setup.crs_items, function (crs_item) {
                          return _c(
                            _setup.Collapse,
                            {
                              key: crs_item.epsg,
                              attrs: { selected: false },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "crs-item-header" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "crs-item-header__title",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(crs_item.name) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "crs-item-header__action",
                                              },
                                              [
                                                !crs_item.default
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "layer-item__button",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _setup.onRemove(
                                                              crs_item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(_setup.SvgIcon, {
                                                          attrs: {
                                                            size: "14",
                                                            type: "mdi",
                                                            path: _setup.path
                                                              .delete,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("div", { staticClass: "crs-item" }, [
                                _c(
                                  "div",
                                  [
                                    _c(_setup.InputText, {
                                      attrs: {
                                        readonly: crs_item.default,
                                        value: crs_item.name,
                                        label: _setup.$map.trans(
                                          "map.crs-control.field.name"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          crs_item.name = $event
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _c(_setup.InputText, {
                                      attrs: {
                                        readonly: crs_item.default,
                                        value: crs_item.epsg,
                                        label: _setup.$map.trans(
                                          "map.crs-control.field.epsg"
                                        ),
                                      },
                                      on: {
                                        change: function ($event) {
                                          crs_item.epsg = $event
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                !crs_item.default
                                  ? _c(
                                      "div",
                                      [
                                        _c(_setup.InputText, {
                                          attrs: {
                                            value: crs_item.proj4js,
                                            label: _setup.$map.trans(
                                              "map.crs-control.field.proj4js"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              crs_item.proj4js = $event
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !crs_item.default
                                  ? _c(
                                      "div",
                                      [
                                        _c(_setup.InputSelect, {
                                          attrs: {
                                            label: _setup.$map.trans(
                                              "map.crs-control.field.unit"
                                            ),
                                            items: _setup.unit_items,
                                          },
                                          model: {
                                            value: crs_item.unit,
                                            callback: function ($$v) {
                                              _vm.$set(crs_item, "unit", $$v)
                                            },
                                            expression: "crs_item.unit",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        }),
                        _c("div", { staticClass: "crs-item__add" }, [
                          _c(
                            "button",
                            {
                              staticClass: "layer-item__button clickable",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _setup.onAdd()
                                },
                              },
                            },
                            [
                              _c(_setup.SvgIcon, {
                                attrs: {
                                  size: "14",
                                  type: "mdi",
                                  path: _setup.path.plus,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }